module.exports = __webpack_public_path__ + "img/riverbend-greenhouse.e73fa636.jpg";